<template>
  <div>
    <el-dialog
      title="新增"
      :visible.sync="disabled"
      width="700px"
      @close="close"
      :modal="false"
    >
      <el-form
        :model="form"
        ref="formRef"
        size="medium"
        label-position="right"
        label-width="100px"
      >
        <el-form-item label="手机号：" prop="mobile">
          <el-input
            type="textarea"
            :rows="5"
            v-model="inputNums"
            @input="inputNums = inputNums.replace(/[^\d(\n)]/g,'')"
            style="width:500px"
            placeholder="请输入或复制粘贴需要操作的手机号，每行只能有一个手机号，例如：
13366666666
13388888888"
          ></el-input>
        </el-form-item>
        <p style="color: red; text-align: center">
          请确认数据已导入ICCID中,否则将无法添加
        </p>
        <el-form-item
          style="width: 95%; display: flex; justify-content: flex-end"
        >
          <el-button size="small" @click="close" :loading="btnLoading">
            取 消
          </el-button>
          <el-button
            size="small"
            type="primary"
            @click="Recharge('formRef')"
            :loading="btnLoading"
          >
            确 定
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { postData } from "@/api/index";
export default {
  props: {
    isShow: Boolean,
    company_id: Number,
  },
  data() {
    return {
      form: {
        mobile: "",
        company_id: this.company_id,
      },
      inputNums: "",
      disabled: this.isShow,
      btnLoading: false,
    };
  },
  methods: {
    Recharge(form) {
      this.$refs[form].validate(async (valid) => {
        if (valid) {
          const arr = this.inputNums.split('\n').filter(n=>n)
          if(arr.length == 0) return this.$message.error("请输入手机号")
          this.btnLoading = true;
          const params = {
            ...this.form,
            mobile: arr.join(',')
          }
          let res = await postData("company.CompanyUserController/mobileAddAction",params);
          this.btnLoading = false;
          if (res.code !== 200) return this.$message.error(res.message);
          this.$message.success("新增成功");
          this.close();
          this.$parent.searchArr();
        } else {
          return false;
        }
      });
    },
    close() {
      this.inputNums = ''
      this.$emit("close");
    },
  },
};
</script>

<style lang="less" src="@/assets/css/tablecss.less" scoped></style>
